/**
 * Initialize grid item functionality including quick buy, hover effects, and prerendering
 * This function can be called multiple times safely as it handles event binding
 */
function initializeGridItems() {
    $('.shop-grid-item, .shop-grid-item-v2, .shop-grid-item-v5').off('mouseenter.gridItem');
    $('.shop-grid-item-image').off('mouseenter.gridItem');
    $('.shop-grid-large-image, .shop-grid-item-bottom.hide').off('mouseenter.gridItem');
    
    $('.shop-grid-item, .shop-grid-item-v2, .shop-grid-item-v5').each(function(){
        var $this = $(this);
        var $href;
        if (!$this.hasClass('shop-grid-item-v5')) {
            $href = $this.find('.swatches').children('.swatch-wrap').first().children().attr('href');
            $this.find('.shop-grid-item-bottom-title').attr('href', $href)
            $this.find('.shop-grid-item-image').attr('href', $href);
        }
        if($(".quick-buy").length){    
            $this.on("mouseenter.gridItem", function(){
                $(".shop-grid-item").removeClass("quick-shop-active")
                $this.addClass("quick-shop-active");
                var activeGridItemFormVariantID = Number($this.find(".quick-buy-form.active select").val());
                var activeGridItemFormProductTitle = $this.find(`.quick-buy-form.active select option[value="${activeGridItemFormVariantID}"]`).attr("data-headline");
                var activeGridItemFormProductID = Number($this.find(`.quick-buy-form.active select option[value="${activeGridItemFormVariantID}"]`).attr("data-prod-id"));
                var activeGridItemFormVariantWaitlist = $this.find(`.quick-buy-form.active select option[value="${activeGridItemFormVariantID}"]`)[0].hasAttribute("data-disabled") ? true : false;
                window.productGridItem = {
                    title: activeGridItemFormProductTitle,
                    variantID: activeGridItemFormVariantID,
                    productID: activeGridItemFormProductID,
                    waitlist: activeGridItemFormVariantWaitlist
                }
                $(".bis-modal__popup-headline").html("<div>" + activeGridItemFormProductTitle + "</div>")
                if(activeGridItemFormVariantWaitlist){
                    $this.find(".button").hide();
                    $this.find(".bis-button").show();
                } else {
                    $this.find(".button").hide();
                    $this.find(".add-button").show();
                }
            })
        } else {
            $this.find(".line-item-reviews").css("opacity", 1);
        }
    });
    
    $(".shop-grid-item-image").on("mouseenter.gridItem", function(){
        if($(this)[0].hasAttribute("href")){
            if(document.querySelector(".prerender-link") !== null){
                document.querySelector(".prerender-link").remove();
            }
            var newPreLoadLink = document.createElement("link");
            newPreLoadLink.classList.add("prerender-link");
            newPreLoadLink.rel = "prerender";
            newPreLoadLink.href = $(this).attr("href");
            document.head.appendChild(newPreLoadLink);   
        }
    })
    
    $(".shop-grid-large-image, .shop-grid-item-bottom.hide").on("mouseenter.gridItem", function(){
        // $this.removeClass("quick-shop-active");
        // $(".custom-select").select2('close');
    })
}

// Initialize grid items on page load
initializeGridItems();

$('.shop-grid-item-bottom.hide').each(function(){
    var $this = $(this);
    var $href = $this.find('.swatches').children('.swatch-wrap.active').children().attr('href');
    $this.find('.shop-grid-item-bottom-title').attr('href', $href)
})
/**
 * Initialize quick buy select functionality
 */
function initializeQuickBuySelects() {
    // Remove existing event handlers to prevent duplicate bindings
    $(".landing-block-product-grid .quick-buy-mobile select, .shop-grid-item .quick-buy-mobile select, .shop-grid-item-v2.shop-grid-item-quick-shop.shop-grid-item-span-2 .quick-buy-mobile select").off("change.quickBuySelect");
    $(".quick-buy-form select").off("change.quickBuyForm");

// QUICK BUY
if($(".quick-buy").length){
    $(".landing-block-product-grid .quick-buy-mobile select, .shop-grid-item .quick-buy-mobile select, .shop-grid-item-v2.shop-grid-item-quick-shop.shop-grid-item-span-2 .quick-buy-mobile select").on("change.quickBuySelect", function(e){
        if($(window).width() < 768){
            if($(this).val() !== ""){
                window.addItem(`${$(this).parents("form").attr("id")}`)
                //RESET MOBILE SELECTS
                $(".landing-block-product-grid .quick-buy-mobile select").each(function(){
                    var $select = $(this);
                    if($select.find(`option[value=""]`).length){
                        $select.val("");
                    }
                })
                $(".shop-grid-item .quick-buy-mobile select").each(function(){
                    var $select = $(this);
                    if($select.find(`option[value=""]`).length){
                        $select.val("");
                    }
                })
                $(".shop-grid-item-v2.shop-grid-item-quick-shop.shop-grid-item-span-2 .quick-buy-mobile select").each(function(){
                    var $select = $(this);
                    if($select.find(`option[value=""]`).length){
                        $select.val("");
                    }
                })
            }
        }
    })
    $(".quick-buy-form select").on("change.quickBuyForm", function(){
        var $select = $(this);
        var value = $select.val();
        var $form = $select.parents("form");
        var $button = $form.find(".button")
        if(!$select.parents(".quick-buy-mobile").length){
            if($select.find("option[data-price]").length){
                var price = $select.find(`option[value="${value}"]`).attr("data-price");
                $button.html(`<span><span class="money">${price}</span></span> <span>•</span> <span>Quick Buy</span>`)
            }
        }
    })      
}
}
/**
 * Initialize swatch hover functionality for desktop
 */
function initializeSwatchEvents() {

    // Remove existing event handlers to prevent duplicate bindings
    $('.swatches a').off('mouseenter.swatchHover');
    $('.shop-grid-item-bottom.hide .swatches a').off('click.swatchClick mouseenter.swatchHover');
    $('.shop-grid-item-v5 .shop-grid-item-swatches a:not(.shop-grid-item-swatch-count-link)').off('click.swatchClick mouseenter.swatchHover');

    if($(".shop-grid-item-v2").length){
        $(".shop-grid-item-v2").each(function(){
            let $gridItem = $(this);
            // Hide all badges first
            $gridItem.find('.variant-badges .badge').hide(0);
            $(this).find(".swatches .swatch-wrap").each(function(i){
                if(i === 0){
                    $(this).addClass("active");
                    var badge = $(this).data('prod-id');
                    if ($gridItem.find('.badge.badge-' + badge).length) {
                        $gridItem.find('.badge.badge-' + badge).show(0);
                    }        
                }
            });
        });
    }

    if($(".shop-grid-item-v5").length){
        $(".shop-grid-item-v5").each(function(){
            let $gridItem = $(this);
            // Hide all badges first
            $gridItem.find('.variant-badges .badge').hide(0);
            $(this).find(".swatches .swatch-wrap").each(function(i){
                if(i === 0){
                    $(this).addClass("active");
                    var badge = $(this).data('prod-id');
                    if ($gridItem.find('.badge.badge-' + badge).length) {
                        // console.log($gridItem.find('.badge.badge-' + badge))
                        $gridItem.find('.badge.badge-' + badge).show(0);
                    }        
                }
            });         
        });
    }

    
    //DESKTOP
    $('.swatches a').on('mouseenter.swatchHover', function(){
        let $gridItem = $(this).parents('.shop-grid-item-v2, .shop-grid-item-v5');
    $(this).parent().removeClass('active')
    $(this).parent().siblings().removeClass('active')
    $(this).parent().addClass('active')
    var img = $(this).attr('data-image')
    var $href = $(this).attr('href')
    var swatchColor = $(this).attr('data-swatch-color-label')

    if(document.querySelector(".prerender-link") !== null){
        document.querySelector(".prerender-link").remove();
    }
    var newPreLoadLink = document.createElement("link");
    newPreLoadLink.classList.add("prerender-link");
    newPreLoadLink.rel = "prerender"; 
    newPreLoadLink.href = $href;
    document.head.appendChild(newPreLoadLink);   
     
    if($(this)[0].hasAttribute('data-image')){
        $(this).parents('.shop-grid-item-v2, .shop-grid-item-v5').find('.shop-grid-item-image').children().not('.shop-grid-item-badges, .shop-grid-item-hover-image').attr('src', img)
        $(this).parents('.shop-grid-item-v2, .shop-grid-item-v5').find('a.shop-grid-item-image').children().not('.shop-grid-item-badges, .shop-grid-item-hover-image').attr('srcset', `${img}&width=352 352w, ${img}&width=500 500w`)
        $(this).parents('.shop-grid-item-v2, .shop-grid-item-v5').find('a.shop-grid-item-image').attr('href', $href);
        
        // Only hide hover image if the swatch color doesn't match the hover image's data attribute
        var $hoverImage = $(this).parents('.shop-grid-item-v5').find('.shop-grid-item-hover-image');
        var hoverImageSwatchColor = $hoverImage.attr('data-swatch-color-hover-image');
        if (swatchColor !== hoverImageSwatchColor) {
            $hoverImage.addClass('shop-grid-item-hover-image--hidden');
        } else {
            $hoverImage.removeClass('shop-grid-item-hover-image--hidden');
        }
    }
 
    $(this).parents('.shop-grid-item-v2').find('a.shop-grid-item-bottom-title').attr('href', $href);
    $(this).parents('.shop-grid-item-v5').find('a.shop-grid-item-bottom').attr('href', $href);
    
    // badge hovers
    var badge = $(this).parent('.swatch-wrap').data('prod-id');
    $gridItem.find('.variant-badges .badge').hide(0);
    if ($gridItem.find('.variant-badges .badge.badge-' + badge).length) {
        $gridItem.find('.badge.badge-' + badge).show(0);
    }

    //price updates
    if($(this).data('compare-price')){
        $(this).parents('.shop-grid-item-v2, .shop-grid-item-v5').find(".shop-grid-item-bottom .money").html(`<div class="justify-end"><span style="display:inline-block; color:#FF965B;">${Shopify.formatMoney($(this).data('price')).replace(".00", "")}</span><span style="display:inline-block; text-decoration:line-through;padding-left:5px;">${Shopify.formatMoney($(this).data('compare-price')).replace(".00", "")}</span></div>`)

        $(this).parents('.shop-grid-item-v5').find(".shop-grid-item-badges").hide();      

    } else if($(this).data('price')) {
        $(this).parents('.shop-grid-item-v2, .shop-grid-item-v5').find(".shop-grid-item-bottom .money").html(`<span>${Shopify.formatMoney($(this).data('price')).replace(".00", "")}</span>`)

        // $(this).parents('.shop-grid-item-v5').find(".shop-grid-item-badges").show();
        if($gridItem.find(".shop-grid-item-badges").length){
            let activeSwatch = $gridItem.find(".swatch-wrap.active");
            let activeProductID = activeSwatch.data('prod-id');
            $gridItem.find(`.shop-grid-item-badges`).hide(0);
            if($gridItem.find(`.shop-grid-item-badges--${activeProductID}`).length){
                $gridItem.find(`.shop-grid-item-badges--${activeProductID}`).show(0);
            } else {
                if($gridItem.find(`.shop-grid-item-badges--main`).length){
                    $gridItem.find(`.shop-grid-item-badges--main`).show(0);
                }
            }
        }  

    }  
    //show active quick buy
    if($(".quick-buy").length){            
        var activeSwatchHandle = $(this).parents('.shop-grid-item-v2, .shop-grid-item-v5').find(".swatch-wrap.active").attr("data-handle");
        if(activeSwatchHandle){
            $(`#quick-buy-${activeSwatchHandle}`).siblings().removeClass("active")
            $(`#quick-buy-${activeSwatchHandle}`).addClass("active");
            var activeGridItemFormVariantID = Number($(this).parents('.shop-grid-item-v2, .shop-grid-item-v5').find(".quick-buy-form.active select").val());
            var activeGridItemFormProductTitle = $(this).parents('.shop-grid-item-v2, .shop-grid-item-v5').find(`.quick-buy-form.active select option[value="${activeGridItemFormVariantID}"]`).attr("data-headline");        
            var activeGridItemFormProductID = Number($(this).parents('.shop-grid-item-v2, .shop-grid-item-v5').find(`.quick-buy-form.active select option[value="${activeGridItemFormVariantID}"]`).attr("data-prod-id"));        
            var activeGridItemFormVariantWaitlist = $(this).parents('.shop-grid-item-v2, .shop-grid-item-v5').find(`.quick-buy-form.active select option[value="${activeGridItemFormVariantID}"]`)[0].hasAttribute("data-disabled") ? true : false;        
            window.productGridItem = {
                title: activeGridItemFormProductTitle,
                variantID: activeGridItemFormVariantID,
                productID: activeGridItemFormProductID,
                waitlist: activeGridItemFormVariantWaitlist
            }
            $(".bis-modal__popup-headline").html("<div>" + activeGridItemFormProductTitle + "</div>")
            if(activeGridItemFormVariantWaitlist){
                $(this).parents('.shop-grid-item-v2, .shop-grid-item-v5').find(".button").hide();
                $(this).parents('.shop-grid-item-v2, .shop-grid-item-v5').find(".bis-button").show();
            } else {
                $(this).parents('.shop-grid-item-v2, .shop-grid-item-v5').find(".button").hide();
                $(this).parents('.shop-grid-item-v2, .shop-grid-item-v5').find(".add-button").show();
            }
        }
    }    
}); 
//MOBILE
function updateMobileQuickBuyButtons() {
    $(".quick-buy-mobile-form.active").each(function(){
        var $form = $(this);
        if($form.find(".size-button.active .size-radio.disabled").length){
            $form.find(".button").hide();
            $form.find(".bis-button").show();
        }
    })
}

$('.shop-grid-item-bottom.hide .swatches a').on('click.swatchClick mouseenter.swatchHover', function(e){
    e.preventDefault();
    $(this).parent().removeClass('active')
    $(this).parent().siblings().removeClass('active')
    $(this).parent().addClass('active')
    var handle = $(this).parent().attr("data-handle");
    var img = $(this).attr('data-image')
    var alt = $(this).attr('data-alt')
    var $href = $(this).attr('href')

    if(document.querySelector(".prerender-link") !== null){
        document.querySelector(".prerender-link").remove();
    }
    var newPreLoadLink = document.createElement("link");
    newPreLoadLink.classList.add("prerender-link");
    newPreLoadLink.rel = "prerender";
    newPreLoadLink.href = $href;
    document.head.appendChild(newPreLoadLink);

    if($(this)[0].hasAttribute('data-image')){
        $(this).parents('.shop-grid-item-bottom.hide').prev().find('.shop-grid-item-image').children().attr('src', img)
        $(this).parents('.shop-grid-item-bottom.hide').prev().find('.shop-grid-item-image').children().attr('srcset', `${img}&width=352 352w, ${img}&width=500 500w`)
        $(this).parents('.shop-grid-item-bottom.hide').prev().find('.shop-grid-item-image').children().attr('alt', alt)
    }
    $(this).parents('.shop-grid-item-bottom.hide').prev().find('a.shop-grid-item-image').attr('href', $href);
    $(this).parents('.shop-grid-item-bottom.hide').find('a.shop-grid-item-bottom-title').attr('href', $href);
    //price updates     
    if($(this).data('compare-price')){
        $(this).parents('.shop-grid-item-bottom.hide').find(".money").html(`<div class="flex-row justify-end"><span style="display:inline-block; color:#FF965B;">${Shopify.formatMoney($(this).data('price')).replace(".00", "")}</span><span style="display:inline-block; text-decoration:line-through;padding-left:5px;">${Shopify.formatMoney($(this).data('compare-price')).replace(".00", "")}</span></div>`)

        $(this).parents('.shop-grid-item-bottom.hide').find(".shop-grid-item-badges").hide();

    } else if($(this).data('price')) {
        $(this).parents('.shop-grid-item-bottom.hide').find(".money").html(`<span>${Shopify.formatMoney($(this).data('price')).replace(".00", "")}</span>`)

        // $(this).parents('.shop-grid-item-bottom.hide').find(".shop-grid-item-badges").show();
        if($(this).parents('.shop-grid-item-bottom.hide').find(".shop-grid-item-badges").length){
            let activeSwatch = $(this).parents('.shop-grid-item-bottom.hide').find(".swatch-wrap.active");
            let activeProductID = activeSwatch.data('prod-id');
            $(this).parents('.shop-grid-item-bottom.hide').find(`.shop-grid-item-badges`).hide(0);
            if($(this).parents('.shop-grid-item-bottom.hide').find(`.shop-grid-item-badges--${activeProductID}`).length){
                $(this).parents('.shop-grid-item-bottom.hide').find(`.shop-grid-item-badges--${activeProductID}`).show(0);
            } else {
                if($(this).parents('.shop-grid-item-bottom.hide').find(`.shop-grid-item-badges--main`).length){
                    $(this).parents('.shop-grid-item-bottom.hide').find(`.shop-grid-item-badges--main`).show(0);
                }
            }
        }  

    }    
    //quick buy mobile
    $(`#quick-buy-mobile-${handle}`).siblings().removeClass("active")
    $(`#quick-buy-mobile-${handle}`).addClass("active")
    if($(".quick-buy").length){   
        updateMobileQuickBuyButtons();
    }
});  

// Mobile V5 Grid Item Swatches - Only enabled on mobile devices (992px or less)
$('.shop-grid-item-v5 .shop-grid-item-swatches a:not(.shop-grid-item-swatch-count-link)').on('click.swatchClick mouseenter.swatchHover', function(e){
  if($(window).width() > 992) {
    return;
  }
  
  // Don't handle clicks on swatches within mobile quick buy drawer
  if ($(this).closest('.shop-grid-item__quick-buy').length > 0) {
    return;
  }
  
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();
  $(this).parent().removeClass('active')
  $(this).parent().siblings().removeClass('active')
  $(this).parent().addClass('active')
  var handle = $(this).parent().attr("data-handle");
  var img = $(this).attr('data-image')
  var alt = $(this).attr('data-alt')
  var $href = $(this).attr('href')

  if(document.querySelector(".prerender-link") !== null){
      document.querySelector(".prerender-link").remove();
  }
  var newPreLoadLink = document.createElement("link");
  newPreLoadLink.classList.add("prerender-link");
  newPreLoadLink.rel = "prerender";
  newPreLoadLink.href = $href;
  document.head.appendChild(newPreLoadLink);

  if($(this)[0].hasAttribute('data-image')){
      $(this).parents('.shop-grid-item-v5').find('.shop-grid-item-image').children().attr('src', img)
      $(this).parents('.shop-grid-item-v5').find('.shop-grid-item-image').children().attr('srcset', `${img}&width=352 352w, ${img}&width=500 500w`)
      $(this).parents('.shop-grid-item-v5').find('.shop-grid-item-image').children().attr('alt', alt)
  }
  $(this).parents('.shop-grid-item-v5').find('a.shop-grid-item-image').attr('href', $href);
  $(this).parents('.shop-grid-item-v5').find('a.shop-grid-item-bottom').attr('href', $href);

  //price updates     
  if($(this).data('compare-price')){
      $(this).parents('.shop-grid-item-v5').find(".shop-grid-item-bottom .money").html(`<div class="flex-row"><span style="display:inline-block; color:#FF965B;">${Shopify.formatMoney($(this).data('price')).replace(".00", "")}</span><span style="display:inline-block; text-decoration:line-through;padding-left:5px;">${Shopify.formatMoney($(this).data('compare-price')).replace(".00", "")}</span></div>`)
      $(this).parents('.shop-grid-item-v5').find(".shop-grid-item-badges").hide();
  } else if($(this).data('price')) {
      $(this).parents('.shop-grid-item-v5').find(".shop-grid-item-bottom .money").html(`<span>${Shopify.formatMoney($(this).data('price')).replace(".00", "")}</span>`)

    //   $(this).parents('.shop-grid-item-v5').find(".shop-grid-item-badges").show();

    var $gridItem = $(this).parents('.shop-grid-item-v5');
    if($gridItem.find(".shop-grid-item-badges").length){
        let activeSwatch = $gridItem.find(".swatch-wrap.active");
        let activeProductID = activeSwatch.data('prod-id');
        $gridItem.find(`.shop-grid-item-badges`).hide(0);
        if($gridItem.find(`.shop-grid-item-badges--${activeProductID}`).length){
            $gridItem.find(`.shop-grid-item-badges--${activeProductID}`).show(0);
        } else {
            if($gridItem.find(`.shop-grid-item-badges--main`).length){
                $gridItem.find(`.shop-grid-item-badges--main`).show(0);
            }
        }
    }      

  }    
  //quick buy mobile
  $(`#quick-buy-mobile-${handle}`).siblings().removeClass("active")
  $(`#quick-buy-mobile-${handle}`).addClass("active")
  if($(".quick-buy").length){   
      updateMobileQuickBuyButtons();
  }
});  
}

/**
 * Initialize active swatch badges and prices
 */
function initializeActiveSwatchBadges() {
// get first active swatch badge if there is one + update prices
$('.swatches .swatch-wrap.active').each(function() {
    var $gridItem = $(this).parents('.shop-grid-item-v2, .shop-grid-item-v5');
    // Hide all badges first for this grid item
    $gridItem.find('.variant-badges .badge').hide(0);
    var firstActiveProdId = $(this).data('prod-id');
    if ($gridItem.find('.variant-badges .badge.badge-' + firstActiveProdId).length) {
        $gridItem.find('.badge.badge-' + firstActiveProdId).show(0);
    }
    if($(this).children("a").data('compare-price')){
        $(this).parents('.shop-grid-item-v2, .shop-grid-item-v5').find(".shop-grid-item-bottom .money").html(`<div class="flex-row justify-end"><span style="display:inline-block; color:#FF965B;">${Shopify.formatMoney($(this).children("a").data('price')).replace(".00", "")}</span><span style="display:inline-block; text-decoration:line-through;padding-left:5px;">${Shopify.formatMoney($(this).children("a").data('compare-price')).replace(".00", "")}</span></div>`)
        $(this).parents('.shop-grid-item-bottom.hide').find(".money").html(`<div class="flex-row justify-end"><span style="display:inline-block; color:#FF965B;">${Shopify.formatMoney($(this).children("a").data('price')).replace(".00", "")}</span><span style="display:inline-block; text-decoration:line-through;padding-left:5px;">${Shopify.formatMoney($(this).children("a").data('compare-price')).replace(".00", "")}</span></div>`)
        $(this).parents('.shop-grid-item-v2, .shop-grid-item-v5').find(".shop-grid-item-badges").hide();    

    } else if($(this).children("a").data('price')) {
        $(this).parents('.shop-grid-item-v2, .shop-grid-item-v5').find(".shop-grid-item-bottom .money").text(Shopify.formatMoney($(this).children("a").data('price')).replace(".00", ""))
        $(this).parents('.shop-grid-item-bottom.hide').find(".money").text(Shopify.formatMoney($(this).children("a").data('price')).replace(".00", ""))
        
        // $(this).parents('.shop-grid-item-v2, .shop-grid-item-v5').find(".shop-grid-item-badges").show();

        if($(this).parents('.shop-grid-item-v2, .shop-grid-item-v5').find(".shop-grid-item-badges").length){
            let activeSwatch = $(this).parents('.shop-grid-item-v2, .shop-grid-item-v5').find(".swatch-wrap.active");
            let activeProductID = activeSwatch.data('prod-id');
            $(this).parents('.shop-grid-item-v2, .shop-grid-item-v5').find(`.shop-grid-item-badges`).hide(0);
            if($(this).parents('.shop-grid-item-v2, .shop-grid-item-v5').find(`.shop-grid-item-badges--${activeProductID}`).length){
                $(this).parents('.shop-grid-item-v2, .shop-grid-item-v5').find(`.shop-grid-item-badges--${activeProductID}`).show(0);
            } else {
                if($(this).parents('.shop-grid-item-v2, .shop-grid-item-v5').find(`.shop-grid-item-badges--main`).length){
                    $(this).parents('.shop-grid-item-v2, .shop-grid-item-v5').find(`.shop-grid-item-badges--main`).show(0);
                }
            }
        }    

    }                  
});
}
/**
 * Initialize quick buy mobile functionality
 */
function initializeQuickBuyMobile() {
    // Remove existing event handlers to prevent duplicate bindings
    if($(".quick-buy").length){
        $(".quick-buy-mobile-form .size-radio").off('click.quickBuy');
        $(".quick-buy-mobile-form .bis-button").off('click.quickBuy');
    }

// quick buy mobile size buttons
var selectedSize;
function updateMobileQuickBuySelects () {
    var mobileSelectSizeRadios = $(`.quick-buy-mobile-form .size-radio[value="${selectedSize}"]:not(.disabled)`);
    var mobileSelectSoldOutSizeRadios = $(`.quick-buy-mobile-form .size-radio[value="${selectedSize}"].disabled`);
    if(mobileSelectSizeRadios.length){
        mobileSelectSizeRadios.each(function(){
            var $radio = $(this);
            var id = $radio.attr("data-id");
            $radio.parent().addClass("active"); 
            $radio.parent().siblings().removeClass("active");
            $radio.parents(".quick-buy-mobile-form").find(".button").hide();
            $radio.parents(".quick-buy-mobile-form").find(".add-button").show();
            $radio.parents(".quick-buy-mobile-form").find("select").val(id).trigger("change");
            // console.log($radio.parents(".quick-buy-mobile-form").find("select").val(id))
        })
    }
    if(mobileSelectSoldOutSizeRadios.length){
        mobileSelectSoldOutSizeRadios.each(function(){
            var $radio = $(this);
            var id = $radio.attr("data-id");
            $radio.parent().addClass("active"); 
            $radio.parent().siblings().removeClass("active");
            updateMobileQuickBuyButtons()
            // $radio.parents(".quick-buy-mobile-form").find("select").val(id).trigger("change");
            // console.log($radio.parents(".quick-buy-mobile-form").find("select").val(id))
        })
    }
}
if($(".quick-buy").length){
    $(".quick-buy-mobile-form").each(function(){
        var $form = $(this);
        $form.find(".size-radio").on("click.quickBuy", function(){
            var handle = $(this).attr("data-handle");
            var $this = $(`#quick-buy-mobile-${handle}`);
            var $select = $(`#quick-buy-mobile-select-${handle}`);
            var id = $(this).attr("data-id");
            selectedSize = $(this).val();
            $select.val(id);
            $this.find(".size-button").removeClass("active");
            $(this).parent().addClass("active");
            updateMobileQuickBuySelects();
        })
    })
    $(".quick-buy-mobile-form .bis-button").on("click.quickBuy", function(e){
        e.preventDefault();
        var $form = $(this).parents(".quick-buy-mobile-form");
        var $activeSizeButton = $form.find(".size-button.active input");
        window.productGridItem = {
            title: $activeSizeButton.attr("data-headline"),
            variantID: Number($activeSizeButton.attr("data-id")),
            productID: Number($activeSizeButton.attr("data-prod-id")),
            waitlist: true
        }
        $(".bis-modal__popup-headline").html("<div>" + window.productGridItem.title + "</div>")
        $('.bis-modal__popup-wrap').addClass('active');
    })
    updateMobileQuickBuyButtons()
}
}

/**
 * NEW QUICK BUY SYSTEM - Separate from old quick buy and limited to v5 grid items
 * Handles auto-add to cart on size selection and swatch hover form switching
 */

/**
 * Update CSS variable for quick buy height based on tallest quick buy item (desktop only)
 */
function updateQuickBuyHeight($gridItem) {
    if (!$gridItem.length) return;
    
    // Find all quick buy items in this grid item
    const $allQuickBuyItems = $gridItem.find('.shop-grid-item__quick-buy-item');
    
    if ($allQuickBuyItems.length === 0) {
        $gridItem[0].style.setProperty('--quick-buy-height', '0px');
        return;
    }
    
    // Store original hidden states
    const originalStates = [];
    $allQuickBuyItems.each(function() {
        originalStates.push($(this).attr('hidden') !== undefined);
    });
    
    // Temporarily show all items to measure their heights
    $allQuickBuyItems.each(function(index) {
        $(this).removeAttr('hidden');
    });
    
    // Find the tallest one
    let maxHeight = 0;
    $allQuickBuyItems.each(function() {
        const height = Math.round(this.getBoundingClientRect().height);
        if (height > maxHeight) {
            maxHeight = height;
        }
    });
    
    // Restore original hidden states
    $allQuickBuyItems.each(function(index) {
        if (originalStates[index]) {
            $(this).attr('hidden', true);
        } else {
            $(this).removeAttr('hidden');
        }
    });
    
    // Set CSS variable with the tallest height (for desktop)
    $gridItem[0].style.setProperty('--quick-buy-height', maxHeight + 'px');
}

/**
 * Initialize quick buy height for all grid items on page load
 */
function initializeQuickBuyHeights() {
    $('.shop-grid-item-v5[data-product-id]').each(function() {
        const $gridItem = $(this);
        updateQuickBuyHeight($gridItem);
    });
}

// Recalculate quick buy heights on resize
var quickBuyResizeTimer;
$(window).on('resize', function() {
    clearTimeout(quickBuyResizeTimer);
    quickBuyResizeTimer = setTimeout(function() {
        initializeQuickBuyHeights();
    }, 150);
});

/**
 * Initialize new quick buy swatch hover functionality
 * Shows/hides quick buy forms based on swatch hover
 */
function initializeNewQuickBuySwatchHover() {
    // Remove existing event handlers to prevent duplicate bindings
    $('.shop-grid-item-v5 .shop-grid-item-swatches .swatch-wrap').off('mouseenter.newQuickBuySwatch mouseleave.newQuickBuySwatch click.newQuickBuySwatch');
    $('.shop-grid-item-v5 .shop-grid-item-swatches a').off('click.newQuickBuySwatch');
    
    // Prevent swatch link clicks when clicking within quick buy area
    $('.shop-grid-item-v5 .shop-grid-item__quick-buy').on('click.newQuickBuySwatch', function(e) {
        if ($(e.target).closest('quick-buy-pack-sizes, .quick-buy-pack-sizes, .shop-grid-item__quick-buy-close').length) {
            return;
        }
        e.stopPropagation();
    });
    
    // Clicking a swatch switches the quick buy form (same as hover) and prevents navigation
    $('.shop-grid-item-v5 .shop-grid-item-swatches a').on('click.newQuickBuySwatch', function(e) {
        // Don't handle clicks on swatches within the quick buy drawer
        if ($(this).closest('.shop-grid-item__quick-buy').length > 0) {
            return;
        }

        e.preventDefault();
        e.stopPropagation();

        const $swatchLink = $(this);
        const $swatchWrap = $swatchLink.closest('.swatch-wrap');
        const $gridItem = $swatchWrap.parents('.shop-grid-item-v5');
        const productId = $swatchWrap.data('prod-id');

        // Hide all quick buy items in this grid item
        $gridItem.find('.shop-grid-item__quick-buy-item').attr('hidden', true);

        // Show the matching quick buy item
        const $matchingQuickBuy = $gridItem.find(`.shop-grid-item__quick-buy-item[data-ref="${productId}"]`);
        if ($matchingQuickBuy.length) {
            $matchingQuickBuy.removeAttr('hidden');
            setTimeout(() => updateQuickBuyHeight($gridItem), 0);
            syncQuickBuyPackAfterSwatchChange($gridItem);
        }
    });
    
    $('.shop-grid-item-v5 .shop-grid-item-swatches .swatch-wrap').on('mouseenter.newQuickBuySwatch', function() {
        const $swatchWrap = $(this);
        const $gridItem = $swatchWrap.parents('.shop-grid-item-v5');
        const productId = $swatchWrap.data('prod-id');

        // Hide all quick buy items in this grid item
        $gridItem.find('.shop-grid-item__quick-buy-item').attr('hidden', true);

        // Show the matching quick buy item
        const $matchingQuickBuy = $gridItem.find(`.shop-grid-item__quick-buy-item[data-ref="${productId}"]`);
        if ($matchingQuickBuy.length) {
            $matchingQuickBuy.removeAttr('hidden');
            
            // Update height after showing the new quick buy item
            setTimeout(() => updateQuickBuyHeight($gridItem), 0);
            syncQuickBuyPackAfterSwatchChange($gridItem);
        }
    });
    
    // Optional: On mouseleave, revert to active swatch's quick buy form
    $('.shop-grid-item-v5 .shop-grid-item-swatches .swatch-wrap').on('mouseleave.newQuickBuySwatch', function() {
        const $swatchWrap = $(this);
        const $gridItem = $swatchWrap.parents('.shop-grid-item-v5');
        const $activeSwatch = $gridItem.find('.swatch-wrap.active');

        if ($activeSwatch.length) {
            const activeProductId = $activeSwatch.data('prod-id');

            // Hide all quick buy items
            $gridItem.find('.shop-grid-item__quick-buy-item').attr('hidden', true);

            // Show the active swatch's quick buy item
            const $activeQuickBuy = $gridItem.find(`.shop-grid-item__quick-buy-item[data-ref="${activeProductId}"]`);
            if ($activeQuickBuy.length) {
                $activeQuickBuy.removeAttr('hidden');
                
                // Update height after showing the active quick buy item
                setTimeout(() => updateQuickBuyHeight($gridItem), 0);
                syncQuickBuyPackAfterSwatchChange($gridItem);
            }
        }
    });
}

function syncQuickBuyPackAfterSwatchChange($gridItem) {
    if (!$gridItem || !$gridItem.length || typeof window.syncQuickBuyPackForProductCard !== 'function') return;
    var drawerEl = $gridItem.find('.shop-grid-item__quick-buy')[0];
    if (!drawerEl) {
        var $drawer = findQuickBuyByInstance(quickBuyInstanceKey($gridItem), $gridItem.data('product-id'));
        if (!$drawer.length) return;
        drawerEl = $drawer[0];
    }
    if (drawerEl) window.syncQuickBuyPackForProductCard(drawerEl);
}

/**
 * Helper function to preserve size selection across all variants in a grid item
 */
/** Keep the drawer's "View product details" link pointing at the chosen size's variant. */
function updateQuickBuyDetailsLink($quickBuyItem, variantId) {
    if (!$quickBuyItem || !$quickBuyItem.length || !variantId) return;
    $quickBuyItem.find('.shop-grid-item__quick-buy-details-link').each(function() {
        const href = this.getAttribute('href') || '';
        this.setAttribute('href', /[?&]variant=/.test(href)
            ? href.replace(/([?&]variant=)[^&#]*/, '$1' + variantId)
            : href + (href.indexOf('?') > -1 ? '&' : '?') + 'variant=' + variantId);
    });
}

function syncSizeAcrossVariants($gridItem, selectedSizeLabel) {
    if (!selectedSizeLabel || !selectedSizeLabel.trim()) return;
    
    // Find all quick buy items in the grid item (desktop)
    const $desktopQuickBuyItems = $gridItem.find('.shop-grid-item__quick-buy-item');
    
    // Also find mobile quick buy items (may be in body)
    const productId = $gridItem.data('product-id');
    const $mobileQuickBuy = findQuickBuyByInstance(quickBuyInstanceKey($gridItem), productId);
    const $mobileQuickBuyItems = $mobileQuickBuy.find('.shop-grid-item__quick-buy-item');
    
    // Combine both desktop and mobile items
    const $allQuickBuyItems = $desktopQuickBuyItems.add($mobileQuickBuyItems);
    
    // Loop through all quick buy items (all variants) 
    $allQuickBuyItems.each(function() {
        const $quickBuyItem = $(this);
        const $form = $quickBuyItem.find('form');
        
        // Find the matching size by label in this variant's form
        $form.find('.size-button').each(function() {
            const $button = $(this);
            const label = $button.find('.radio-button-label').text().trim();
            const $radio = $button.find('.size-radio');
            
            // If this is the matching size
            if (label === selectedSizeLabel.trim()) {
                // Remove active from all sizes in this form
                $form.find('.size-button').removeClass('active');
                
                // If it's available, select it
                if (!$radio.hasClass('disabled') && !$radio.is(':disabled')) {
                    $button.addClass('active');
                    $radio.prop('checked', true);
                    
                    // Update the hidden variant ID input
                    const variantId = $radio.val();
                    $form.find('.quick-buy-variant-id').val(variantId);
                    updateQuickBuyDetailsLink($quickBuyItem, variantId);
                    if (typeof window.refreshQuickBuyPackAvailabilityForQuickBuyForm === 'function') {
                        window.refreshQuickBuyPackAvailabilityForQuickBuyForm($form[0]);
                    }
                } else {
                    // If not available, select first available
                    const $firstAvailable = $form.find('.size-radio:not(.disabled):not(:disabled)').first();
                    if ($firstAvailable.length) {
                        $firstAvailable.closest('.size-button').addClass('active');
                        $firstAvailable.prop('checked', true);
                        
                        // Update the hidden variant ID input
                        const variantId = $firstAvailable.val();
                        $form.find('.quick-buy-variant-id').val(variantId);
                        updateQuickBuyDetailsLink($quickBuyItem, variantId);
                        if (typeof window.refreshQuickBuyPackAvailabilityForQuickBuyForm === 'function') {
                            window.refreshQuickBuyPackAvailabilityForQuickBuyForm($form[0]);
                        }
                    }
                }
                return false; // Break the loop
            }
        });
    });
}

/**
 * Initialize new quick buy size selection and auto-add to cart
 */
function initializeNewQuickBuySizeSelection() {
    // Remove existing event handlers to prevent duplicate bindings
    $('.shop-grid-item-v5 .shop-grid-item__quick-buy-item .size-radio').off('change.newQuickBuySize click.newQuickBuySize');
    $('.shop-grid-item-v5 .shop-grid-item__quick-buy-item .size-button').off('click.newQuickBuySize');
    $('.shop-grid-item-v5 .shop-grid-item__quick-buy-item').off('click.newQuickBuySize');
    
    // Prevent clicks within quick buy area from bubbling to swatch links (except title, image links, and size buttons)
    $('.shop-grid-item-v5 .shop-grid-item__quick-buy-item').on('click.newQuickBuySize', function(e) {
        // Allow clicks on title / image / "View product details" links in the mobile drawer
        if ($(e.target).closest('a.shop-grid-item-title').length || 
            $(e.target).closest('.shop-grid-item-mobile-header-image a').length ||
            $(e.target).closest('.shop-grid-item__quick-buy-details-link').length) {
            return; // Let the link navigate
        }
        
        // Allow clicks on size buttons
        if ($(e.target).closest('.size-button').length) {
            return; // Let the size button handler work
        }

        // Pack-size pills (custom element + class); must not be swallowed or document-level handler never runs
        if ($(e.target).closest('quick-buy-pack-sizes, .quick-buy-pack-sizes').length) {
            return;
        }

        // Mobile drawer close button: handled by the document-level handler in initializeMobileQuickBuy
        if ($(e.target).closest('.shop-grid-item__quick-buy-close').length) {
            return;
        }
        
        e.stopPropagation();
        e.preventDefault();
    });
    
    // Handle clicks on size buttons/labels
    $('.shop-grid-item-v5 .shop-grid-item__quick-buy-item .size-button').on('click.newQuickBuySize', function(e) {
        e.stopPropagation();
        e.preventDefault();
        
        const $label = $(this);
        const $radio = $label.find('.size-radio');
        const $form = $label.closest('form');
        const $gridItem = $label.closest('.shop-grid-item-v5');
        
        // Only proceed if radio is not disabled
        if (!$radio.hasClass('disabled') && !$radio.is(':disabled')) {
            // Get the size label
            const sizeLabel = $label.find('.radio-button-label').text().trim();
            
            // Update active state immediately on this form
            $form.find('.size-button').removeClass('active');
            $label.addClass('active');
            
            // Check the radio button and trigger change
            $radio.prop('checked', true).trigger('change');
            
            // Sync this size selection across all variants in this grid item
            if ($gridItem.length) {
                syncSizeAcrossVariants($gridItem, sizeLabel);
            }
        }
    });
    
    // Handle radio change events
    $('.shop-grid-item-v5 .shop-grid-item__quick-buy-item .size-radio').on('change.newQuickBuySize', function(e) {
        e.stopPropagation();
        
        const $radio = $(this);
        const $form = $radio.closest('form');
        
        // Only proceed if radio is checked and not disabled
        if ($radio.is(':checked') && !$radio.hasClass('disabled') && !$radio.is(':disabled')) {
            // Update the hidden input with name="id" 
            const variantId = $radio.val();
            $form.find('.quick-buy-variant-id').val(variantId);
            
            // Update active state on size buttons
            $form.find('.size-button').removeClass('active');
            $radio.closest('.size-button').addClass('active');
        }
    });
    
    // Handle "Add to Cart" button clicks - reset button and close mobile drawer if applicable
    $(document).on('mousedown', '.shop-grid-item__quick-buy-add-to-cart-btn', function(e) {
        const $button = $(this);
        const $quickBuy = $button.closest('.shop-grid-item__quick-buy');

        // Remember the priced label ("$62 • Add to Cart") before the inline onclick swaps in "Adding..."
        const labelHtml = $button.html();
        
        // Reset button text after a delay
        setTimeout(function() {
            if (labelHtml && labelHtml.indexOf('Adding...') === -1) {
                $button.html(labelHtml);
            } else {
                $button.text('Add to Cart');
            }
            $button.prop('disabled', false);
            if (typeof window.initializeQuickBuyPackSizes === 'function') {
                window.initializeQuickBuyPackSizes();
            }
            
            // Close mobile quick buy after adding to cart (only on mobile)
            if ($(window).width() <= 767 && $quickBuy.hasClass('open')) {
                closeMobileQuickBuy($quickBuy);
            }
        }, 1000);
    });
}

/**
 * Fallback function to add to cart directly if addItem is not available
 */
function addToCartDirectly($form) {
    const formData = {};
    
    // Collect form data (including the hidden input with name="id")
    $form.find('input[type="hidden"]').each(function() {
        const $input = $(this);
        formData[$input.attr('name')] = $input.val();
    });
    
    // Get selected variant ID from hidden input (which should be set by the change handler)
    const selectedVariantId = $form.find('.quick-buy-variant-id').val();
    if (!selectedVariantId) {
        return;
    }
    
    formData.id = selectedVariantId;
    formData.quantity = formData.quantity || 1;
    
    // Add to cart
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({
            ...formData,
            sections: "cart-drawer"
        }),
        error: function (obj, status) {
            alert('The product you are trying to add is out of stock.');
        }
    })
    .done(function (data) {
        if (typeof updateCartContents === 'function') {
            updateCartContents(data);
        }
        if (typeof updateCartStuff === 'function') {
            updateCartStuff();
        }
        if (typeof showCart === 'function') {
            showCart();
        }
    });
}

/**
 * Per-card instance keys for the quick buy.
 * The same product can be rendered by several blocks on one page (e.g. the legacy
 * collection section), so product id alone is ambiguous: looking things up by it
 * cloned every matching card's swatches into the drawer and opened every matching
 * drawer. Each card gets a unique data-qb-key shared with its drawer, its mobile
 * info row and its trigger, and the drawer id / aria-controls are made unique.
 */
var quickBuyInstanceCounter = 0;
function assignQuickBuyInstanceKeys() {
    $('.shop-grid-item-v5[data-product-id]:not(.shop-grid-item-bottom)').each(function() {
        const $card = $(this);
        if ($card.attr('data-qb-key')) return;

        const productId = $card.attr('data-product-id');
        const key = productId + '-' + (++quickBuyInstanceCounter);
        $card.attr('data-qb-key', key);

        // Legacy section renders the mobile title/price/swatches row as the next sibling
        const $mobileInfo = $card.next('.shop-grid-item-bottom.hide.shop-grid-item-v5');
        if ($mobileInfo.length && $mobileInfo.attr('data-product-id') === productId) {
            $mobileInfo.attr('data-qb-key', key);
        }

        const $drawer = $card.find('.shop-grid-item__quick-buy').first();
        if (!$drawer.length) return;
        $drawer.attr('data-qb-key', key);

        // Unique drawer id, and point this card's trigger(s) at it
        const oldId = $drawer.attr('id');
        const newId = 'quick-buy-mobile-' + key;
        $drawer.attr('id', newId);
        $card.add($mobileInfo).find('.shop-grid-item-quick-buy-trigger').each(function() {
            if (!oldId || $(this).attr('aria-controls') === oldId) {
                $(this).attr('aria-controls', newId);
            }
        });

        // De-duplicate the title ids the drawer's aria-labelledby points at
        const labelledBy = $drawer.attr('aria-labelledby');
        $drawer.find('[id]').each(function() {
            const id = $(this).attr('id');
            if (id === newId) return;
            const uniqueId = id + '-' + quickBuyInstanceCounter;
            $(this).attr('id', uniqueId);
            if (labelledBy === id) {
                $drawer.attr('aria-labelledby', uniqueId);
            }
        });
    });
}

function quickBuyInstanceKey(el) {
    const $el = $(el);
    if (!$el.length) return '';
    return $el.attr('data-qb-key') || $el.closest('[data-qb-key]').attr('data-qb-key') || '';
}

// Drawer for a card instance, wherever it currently lives (card or body).
// Falls back to product id (first match) for markup that has no key, then to $fallback.
function findQuickBuyByInstance(key, productId, $fallback) {
    let $found = key ? $(`.shop-grid-item__quick-buy[data-qb-key="${key}"]`) : $();
    if (!$found.length && productId) {
        $found = $(`.shop-grid-item__quick-buy[data-product-id="${productId}"]`).first();
    }
    if (!$found.length && $fallback && $fallback.length) {
        $found = $fallback;
    }
    return $found;
}

function findGridCardByInstance(key, productId, $fallback) {
    let $found = key ? $(`.shop-grid-item-v5[data-qb-key="${key}"]:not(.shop-grid-item-bottom)`) : $();
    if (!$found.length && productId) {
        $found = $(`.shop-grid-item-v5[data-product-id="${productId}"]:not(.shop-grid-item-bottom)`).first();
    }
    if (!$found.length && $fallback && $fallback.length) {
        $found = $fallback;
    }
    return $found;
}

function findMobileInfoByInstance(key, productId) {
    let $found = key ? $(`.shop-grid-item-bottom.hide.shop-grid-item-v5[data-qb-key="${key}"]`) : $();
    if (!$found.length && productId) {
        $found = $(`.shop-grid-item-bottom.hide.shop-grid-item-v5[data-product-id="${productId}"]`).first();
    }
    return $found;
}

/**
 * Initialize mobile quick buy functionality
 */
function initializeMobileQuickBuy() {
    // Remove existing event handlers
    $('.shop-grid-item-quick-buy-trigger').off('click.mobileQuickBuy');
    $(document).off('click.mobileQuickBuy');
    $(document).off('click.mobileQuickBuyBackdrop');
    
    // Prevent anchor navigation when clicking within the trigger wrapper
    $(document).on('click.mobileQuickBuy', 'a.shop-grid-item-bottom', function(e) {
        const $clickedElement = $(e.target);
        
        // If clicking on the trigger button or within the trigger wrapper, prevent navigation
        if ($clickedElement.closest('.shop-grid-item-quick-buy-trigger').length ||
            $clickedElement.closest('.shop-grid-item-quick-buy-reviews-trigger-wrapper').length ||
            $clickedElement.hasClass('shop-grid-item-quick-buy-trigger') ||
            $clickedElement.closest('button.shop-grid-item-quick-buy-trigger').length) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
        }
    });
    
    // Close button in the drawer header
    $(document).on('click.mobileQuickBuy', '.shop-grid-item__quick-buy-close', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const $quickBuy = $(this).closest('.shop-grid-item__quick-buy');
        if ($quickBuy.length) {
            closeMobileQuickBuy($quickBuy);
        }
    });

    // Handle trigger button clicks with event delegation
    $(document).on('click.mobileQuickBuy', '.shop-grid-item-quick-buy-trigger', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        const $trigger = $(this);
        const $gridItem = $trigger.closest('.shop-grid-item-v5');
        const productId = $gridItem.data('product-id');
        const instanceKey = quickBuyInstanceKey($gridItem);

        // Find this card's own quick buy (by instance key, so the same product rendered
        // in several blocks doesn't collide), wherever it currently is in the DOM
        let $quickBuy = findQuickBuyByInstance(instanceKey, productId);
        if (!$quickBuy.length) {
            $quickBuy = $gridItem.find('.shop-grid-item__quick-buy');
        }
        if (!$quickBuy.length) {
            return false;
        }
                
        const isOpen = $quickBuy.length > 0 && $quickBuy.hasClass('open');
        
        // Toggle mobile quick buy
        if (isOpen) {
            closeMobileQuickBuy($quickBuy);
        } else {
            // Close any other open mobile quick buys first
            $('.shop-grid-item__quick-buy.open').each(function() {
                const $otherQuickBuy = $(this);
                closeMobileQuickBuy($otherQuickBuy);
            });
            // Small delay to ensure other quick buys are closed
            setTimeout(function() {
                openMobileQuickBuy($gridItem, $quickBuy, $trigger);
            }, 50);
        }
        
        return false;
    });
    
    // Close mobile quick buy when clicking outside the quick buy panel, excpet for clicks on the swatches in the same product context.
    $(document).on('click.mobileQuickBuyBackdrop', function(e) {
        // Don't close if we're updating
        if (window.isUpdatingMobileQuickBuy) {
            return;
        }
        
        const $target = $(e.target);
        const $quickBuy = $target.closest('.shop-grid-item__quick-buy');
        
        // Don't close if clicking on swatches within the drawer (they update the content instead)
        if ($quickBuy.length && $quickBuy.hasClass('open')) {
            if ($target.closest('.shop-grid-item-swatches').length > 0 || 
                $target.closest('.swatch-wrap').length > 0 ||
                $target.closest('a.shop-grid-item-swatch').length > 0) {
                return;
            }
        }
        
        if ($target.closest('.shop-grid-item__quick-buy').length === 0 && 
            $target.closest('.shop-grid-item-quick-buy-trigger').length === 0) {
            $('.shop-grid-item__quick-buy.open').each(function() {
                closeMobileQuickBuy($(this));
            });
        }
    });
    
    // Update mobile quick buy when swatch is clicked/tapped on product card
    $('.shop-grid-item-v5 .shop-grid-item-swatches .swatch-wrap').on('click.mobileQuickBuy', function(e) {
        const $swatchWrap = $(this);
        const $gridItem = $swatchWrap.parents('.shop-grid-item-v5');
        const gridProductId = $gridItem.data('product-id');
        const gridInstanceKey = quickBuyInstanceKey($gridItem);
        
        // Check if there's an open quick buy
        const $openQuickBuy = $('.shop-grid-item__quick-buy.open');
        
        if ($openQuickBuy.length) {
            const openQuickBuyProductId = $openQuickBuy.data('product-id');
            const openQuickBuyInstanceKey = quickBuyInstanceKey($openQuickBuy);
            const isSameCard = (gridInstanceKey && openQuickBuyInstanceKey)
                ? openQuickBuyInstanceKey === gridInstanceKey
                : openQuickBuyProductId === gridProductId;
            
            // If the open quick buy belongs to a different card, close it
            if (!isSameCard) {
                closeMobileQuickBuy($openQuickBuy);
                return;
            }
            
            // If mobile quick buy is open for this same card, update it without closing
            if (isSameCard) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                
                // Prevent scroll handler from closing (temporarily)
                window.isUpdatingMobileQuickBuy = true;
                
                // Find quick buy - check both in grid item and in body (if moved)
                let $quickBuy = $gridItem.find('.shop-grid-item__quick-buy');
                if (!$quickBuy.length) {
                    $quickBuy = findQuickBuyByInstance(gridInstanceKey, gridProductId);
                }
                
                // Update active state on swatches within drawer
                if ($quickBuy.length) {
                    const productId = $swatchWrap.data('prod-id');
                    $quickBuy.find('.shop-grid-item-swatches .swatch-wrap').removeClass('active');
                    $quickBuy.find(`.shop-grid-item-swatches .swatch-wrap[data-prod-id="${productId}"]`).addClass('active');
                    
                    // Update the quick buy content
                    updateMobileQuickBuyForSwatch($gridItem, $swatchWrap);
                }
                
                // Clear the flag after a short delay
                setTimeout(function() {
                    window.isUpdatingMobileQuickBuy = false;
                }, 200);
                
                return false;
            }
        }
    });
}

/**
 * Attach click handlers to mobile drawer swatches
 */
function attachMobileSwatchHandlers($swatchesContainer, $quickBuy, $gridItem) {
    $swatchesContainer.find('a').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        // Set flag immediately
        window.isUpdatingMobileQuickBuy = true;
        
        const $swatchLink = $(this);
        const $swatchWrap = $swatchLink.closest('.swatch-wrap');
        const gridProductId = $quickBuy.data('product-id');
        const productId = $swatchWrap.attr('data-prod-id');
        const $quickBuyItem = $quickBuy.find(`.shop-grid-item__quick-buy-item[data-ref="${productId}"]`);
        
        if ($quickBuyItem.length) {
            // Update active state on swatches within drawer only (don't update desktop)
            $quickBuy.find('.shop-grid-item-swatches .swatch-wrap').removeClass('active');
            $swatchWrap.addClass('active');
            
            // Hide all quick buy items
            $quickBuy.find('.shop-grid-item__quick-buy-item').attr('hidden', true);
            
            // Show the matching quick buy item (same as desktop)
            $quickBuyItem.removeAttr('hidden');
            
            // Move swatches to the new visible item
            const $existingSwatches = $quickBuy.find('.shop-grid-item-swatches');
            if ($existingSwatches.length) {
                $existingSwatches.detach();
                $quickBuyItem.find('.shop-grid-item-mobile-swatches').empty().append($existingSwatches);
            }
            
            // Update mobile header (price, image, swatch name)
            if ($gridItem.length) {
                updateMobileQuickBuyForSwatch($gridItem, $swatchWrap);
            }
            
            // Update height for mobile
            if ($(window).width() <= 767) {
                setTimeout(function() {
                    updateMobileQuickBuyHeight($quickBuy);
                }, 50);
            }
        }
        
        // Clear the flag after a short delay
        setTimeout(function() {
            window.isUpdatingMobileQuickBuy = false;
        }, 200);
        
        return false;
    });
}

/**
 * Update the height CSS variable for mobile quick buy based on visible item
 */
/**
 * Mobile Quick Buy gallery. snippets/quick-buy-mobile-header.liquid emits the PDP gallery data
 * (flat-lay + model shots + model description) as JSON per colour; the slides are only built
 * here, the first time an item is shown, so collection pages don't load gallery images up front.
 * Like the PDP, the model gallery follows the chosen size when that size has its own entry.
 */
function quickBuyGalleryData(root) {
    if (!root) return null;
    if (root.__qbGalleryData !== undefined) return root.__qbGalleryData;
    const script = root.querySelector('script[data-qb-gallery-data]');
    let data = null;
    try {
        data = script ? JSON.parse(script.textContent) : null;
    } catch (err) {
        data = null;
    }
    root.__qbGalleryData = data;
    return data;
}

function quickBuyGalleryIndexForSize(data, sizeLabel) {
    if (!data || !Array.isArray(data.galleries) || !data.galleries.length) return -1;
    const wanted = sizeLabel ? String(sizeLabel).trim().toLowerCase() : '';
    if (wanted) {
        for (let i = 0; i < data.galleries.length; i++) {
            if (String(data.galleries[i].size || '').trim().toLowerCase() === wanted) return i;
        }
    }
    return 0;
}

function renderQuickBuyGallery($item) {
    if (!$item || !$item.length) return;
    const root = $item.find('[data-qb-gallery]')[0];
    if (!root) return;
    const data = quickBuyGalleryData(root);
    if (!data || (!data.main && !(data.galleries && data.galleries.length))) {
        root.setAttribute('hidden', '');
        return;
    }
    const sizeLabel = $item.find('.size-button.active .radio-button-label').first().text();
    const index = quickBuyGalleryIndexForSize(data, sizeLabel);
    if (root.__qbGalleryRendered === index) return;

    const gallery = index >= 0 ? data.galleries[index] : null;
    const slides = [];
    if (data.main) slides.push({ media: data.main, isModel: false });
    if (gallery && Array.isArray(gallery.items)) {
        gallery.items.forEach(function(media) { slides.push({ media: media, isModel: true }); });
    }
    if (!slides.length) {
        root.setAttribute('hidden', '');
        return;
    }

    const track = root.querySelector('[data-qb-gallery-track]');
    track.innerHTML = '';
    slides.forEach(function(slide) {
        const el = document.createElement('div');
        el.className = 'shop-grid-item__quick-buy-gallery-item' + (slide.isModel ? ' shop-grid-item__quick-buy-gallery-item--model' : '');
        if (slide.media.type === 'video') {
            const video = document.createElement('video');
            video.src = slide.media.src;
            if (slide.media.poster) video.poster = slide.media.poster;
            video.muted = true;
            video.loop = true;
            video.autoplay = true;
            video.playsInline = true;
            video.setAttribute('playsinline', '');
            video.setAttribute('muted', '');
            video.preload = 'metadata';
            el.appendChild(video);
        } else {
            const img = document.createElement('img');
            img.src = slide.media.src;
            img.alt = slide.media.alt || '';
            img.loading = 'lazy';
            img.decoding = 'async';
            el.appendChild(img);
        }
        track.appendChild(el);
    });
    track.scrollLeft = 0;

    const caption = root.querySelector('[data-qb-gallery-caption]');
    const text = gallery && gallery.description ? String(gallery.description).trim() : '';
    if (caption) {
        caption.textContent = text;
        if (text) caption.removeAttribute('hidden');
        else caption.setAttribute('hidden', '');
    }
    root.removeAttribute('hidden');
    root.__qbGalleryRendered = index;
}

function renderVisibleQuickBuyGallery($quickBuy) {
    if (!$quickBuy || !$quickBuy.length || $(window).width() > 767) return;
    renderQuickBuyGallery($quickBuy.find('.shop-grid-item__quick-buy-item:not([hidden])').first());
}

function updateMobileQuickBuyHeight($quickBuy) {
    if ($(window).width() > 767) {
        return; // Only on mobile
    }
    
    // Get fresh reference
    const productId = $quickBuy.data('product-id');
    $quickBuy = findQuickBuyByInstance(quickBuyInstanceKey($quickBuy), productId, $quickBuy);
    
    if (!$quickBuy.length) {
        return;
    }
    
    // Find the visible (non-hidden) quick buy item
    const $visibleItem = $quickBuy.find('.shop-grid-item__quick-buy-item:not([hidden])');
    
    if ($visibleItem.length) {
        // Use double requestAnimationFrame to ensure DOM is fully updated and rendered
        requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                // Ensure element is actually visible
                if ($visibleItem.is(':visible') && $visibleItem.css('display') !== 'none') {
                    // Get the actual height including margins and padding
                    const height = $visibleItem.outerHeight(true);
                    
                    // Update the CSS variable (add 32px to the calculated height)
                    if (height && height > 0) {
                        $quickBuy.css('--quick-buy-height', (height + 32) + 'px');
                    } else {
                        // Fallback: try again after a short delay
                        setTimeout(function() {
                            const retryHeight = $visibleItem.outerHeight(true);
                            if (retryHeight && retryHeight > 0) {
                                $quickBuy.css('--quick-buy-height', (retryHeight + 32) + 'px');
                            } else {
                                $quickBuy.css('--quick-buy-height', 'fit-content');
                            }
                        }, 50);
                    }
                } else {
                    // Element not visible yet, try again
                    setTimeout(function() {
                        updateMobileQuickBuyHeight($quickBuy);
                    }, 50);
                }
            });
        });
    }
}

/**
 * Open mobile quick buy panel
 */
function openMobileQuickBuy($gridItem, $quickBuy, $trigger) {
    // Set flag to prevent scroll handler from closing immediately
    window.isOpeningMobileQuickBuy = true;
    
    // Store current scroll position BEFORE any changes
    const scrollY = window.scrollY || window.pageYOffset || 0;
    
    // Get product ID + instance key and ensure we have a fresh reference
    const productId = $gridItem.data('product-id');
    const instanceKey = quickBuyInstanceKey($gridItem) || quickBuyInstanceKey($quickBuy);
    $quickBuy = findQuickBuyByInstance(instanceKey, productId, $quickBuy);
    
    if (!$quickBuy.length) {
        window.isOpeningMobileQuickBuy = false;
        return;
    }
    
    // Store the trigger button reference for focus restoration on close
    if ($trigger && $trigger.length) {
        $quickBuy.data('focus-trigger', $trigger[0]);
    }
    
    // Move swatches from desktop location into the drawer (use ALL swatches for mobile)
    if ($(window).width() <= 767) {
        // Use the hidden container with ALL swatches for mobile drawer
        const $actualGridItem = findGridCardByInstance(instanceKey, productId, $gridItem);
        const $allSwatches = $actualGridItem.find('.shop-grid-item-swatches-all').first();
        if ($allSwatches.length) {
            // Find the visible quick buy item to place swatches after its header
            const $visibleQuickBuyItem = $quickBuy.find('.shop-grid-item__quick-buy-item:not([hidden])').first();
            if ($visibleQuickBuyItem.length) {
                // Clone ALL swatches (don't clone events - we'll attach manually)
                const $swatchesClone = $allSwatches.clone(false);
                // Remove the hidden attribute and add the proper class
                $swatchesClone.removeAttr('hidden').removeClass('shop-grid-item-swatches-all').addClass('shop-grid-item-swatches');
                $visibleQuickBuyItem.find('.shop-grid-item-mobile-swatches').empty().append($swatchesClone);
                
                // Ensure data attributes are preserved on cloned elements
                $swatchesClone.find('.swatch-wrap').each(function(index) {
                    const $cloneWrap = $(this);
                    const $originalWrap = $allSwatches.find('.swatch-wrap').eq(index);
                    const originalProdId = $originalWrap.attr('data-prod-id');
                    const originalHandle = $originalWrap.attr('data-handle');
                    if (originalProdId) {
                        $cloneWrap.attr('data-prod-id', originalProdId);
                    }
                    if (originalHandle) {
                        $cloneWrap.attr('data-handle', originalHandle);
                    }
                });
                
                // Attach click handler to cloned swatches
                attachMobileSwatchHandlers($swatchesClone, $quickBuy, $gridItem);
            }
        }
    }
    
    // Set active state on drawer swatches based on product card swatches
    const $swatchSource = findGridCardByInstance(instanceKey, productId, $gridItem);
    // Check the .hide div first (mobile card swatches the user interacted with), then fall back to actual grid item
    const $hideDiv = findMobileInfoByInstance(instanceKey, productId);
    let $activeSwatch = $hideDiv.find('.shop-grid-item-swatches .swatch-wrap.active');
    if (!$activeSwatch.length) {
        $activeSwatch = $swatchSource.find('.shop-grid-item-swatches .swatch-wrap.active');
    }
    if ($activeSwatch.length && $quickBuy.length) {
        const activeProductId = $activeSwatch.data('prod-id');
        $quickBuy.find('.shop-grid-item-swatches .swatch-wrap').removeClass('active');
        $quickBuy.find(`.shop-grid-item-swatches .swatch-wrap[data-prod-id="${activeProductId}"]`).addClass('active');
    }
    
    // Get active swatch to determine which quick buy item to show
    if ($activeSwatch.length) {
        updateMobileQuickBuyForSwatch($swatchSource, $activeSwatch);
    } else {
        // If no active swatch, show the first one
        const $firstQuickBuyItem = $quickBuy.find('.shop-grid-item__quick-buy-item').first();
        $quickBuy.find('.shop-grid-item__quick-buy-item').attr('hidden', true);
        if ($firstQuickBuyItem.length) {
            $firstQuickBuyItem.removeAttr('hidden');
            // Update price for first item if no active swatch
            const $firstSwatch = $swatchSource.find('.swatch-wrap').first();
            if ($firstSwatch.length) {
                // Set first swatch as active in drawer
                const firstProductId = $firstSwatch.data('prod-id');
                $quickBuy.find('.shop-grid-item-swatches .swatch-wrap').removeClass('active');
                $quickBuy.find(`.shop-grid-item-swatches .swatch-wrap[data-prod-id="${firstProductId}"]`).addClass('active');
                
                updateMobileQuickBuyForSwatch($gridItem, $firstSwatch);
            } else {
                // Still update height even if no swatch update
                setTimeout(function() {
                    updateMobileQuickBuyHeight($quickBuy);
                }, 10);
            }
        }
    }

    
    renderVisibleQuickBuyGallery($quickBuy);

    // Move quick buy to body to ensure it's on top (if on mobile)
    if ($(window).width() <= 767) {
        // Check if already in body
        if (!$quickBuy.parent().is('body')) {
            // Store original parent element reference before moving
            const originalParent = $quickBuy.parent()[0];
            if (originalParent) {
                $quickBuy.data('original-parent-element', originalParent);
            }
            
            $quickBuy.appendTo('body');
            // Get fresh reference after moving
            $quickBuy = findQuickBuyByInstance(instanceKey, productId, $quickBuy);
            
            // Re-bind size button handlers for mobile quick buy items since they're now in body
            $quickBuy.find('.size-button').off('click.mobileQuickBuySize').on('click.mobileQuickBuySize', function(e) {
                e.stopPropagation();
                e.preventDefault();
                
                const $label = $(this);
                const $radio = $label.find('.size-radio');
                const $form = $label.closest('form');
                const $quickBuyContainer = $label.closest('.shop-grid-item__quick-buy');
                
                // Find this drawer's own grid item
                const productId = $quickBuyContainer.data('product-id');
                const $gridItem = findGridCardByInstance(quickBuyInstanceKey($quickBuyContainer), productId);
                
                // Only proceed if radio is not disabled
                if (!$radio.hasClass('disabled') && !$radio.is(':disabled')) {
                    // Get the size label
                    const sizeLabel = $label.find('.radio-button-label').text().trim();
                    
                    // Update active state immediately on this form
                    $form.find('.size-button').removeClass('active');
                    $label.addClass('active');
                    
                    // Check the radio button and trigger change
                    $radio.prop('checked', true).trigger('change');
                    
                    // Sync this size selection across all variants in the grid item
                    if ($gridItem.length) {
                        syncSizeAcrossVariants($gridItem, sizeLabel);
                    }

                    // Show the model gallery for this size when the PDP data has one
                    renderQuickBuyGallery($label.closest('.shop-grid-item__quick-buy-item'));
                    updateMobileQuickBuyHeight($quickBuyContainer);
                }
            });
        }
    }
    
    // The drawer has just been (re)inserted into <body>. Force the browser to compute its closed
    // state (translateY(100svh), opacity 0) now; otherwise adding .open in the same frame gives the
    // transition no start value and the drawer appears instantly instead of sliding up.
    $quickBuy = findQuickBuyByInstance(instanceKey, productId, $quickBuy);
    if ($quickBuy.length) {
        void $quickBuy[0].offsetHeight;
    }

    // Show the quick buy panel
    requestAnimationFrame(function() {
        $quickBuy = findQuickBuyByInstance(instanceKey, productId, $quickBuy);
        
        if ($quickBuy.length) {
            $quickBuy.addClass('open');
            
            // Update height after opening (when element is visible)
            setTimeout(function() {
                updateMobileQuickBuyHeight($quickBuy);
            }, 50);
            
            // Update aria attributes for accessibility
            const quickBuyId = $quickBuy.attr('id');
            if (quickBuyId) {
                const $triggerButton = ($trigger && $trigger.length) ? $trigger : $(`.shop-grid-item-quick-buy-trigger[aria-controls="${quickBuyId}"]`);
                if ($triggerButton.length) {
                    $triggerButton.attr('aria-expanded', 'true');
                }
                
                // Update aria-labelledby to reference the visible title
                const $visibleHeader = $quickBuy.find('.shop-grid-item__quick-buy-item:not([hidden]) .shop-grid-item-title');
                if ($visibleHeader.length) {
                    const titleId = $visibleHeader.attr('id');
                    if (titleId) {
                        $quickBuy.attr('aria-labelledby', titleId);
                    }
                }
            }
            
            // Move focus to the quick buy drawer after it's fully visible
            // Wait for transition to complete (300ms) plus a small buffer
            setTimeout(function() {
                // Get fresh reference in case element was moved
                $quickBuy = findQuickBuyByInstance(instanceKey, productId, $quickBuy);
                
                if (!$quickBuy.length || !$quickBuy.hasClass('open')) {
                    return;
                }
                
                // Find the first visible, focusable element in the drawer (size radio button)
                const $visibleQuickBuyItem = $quickBuy.find('.shop-grid-item__quick-buy-item:not([hidden])');
                if ($visibleQuickBuyItem.length) {
                    const $firstFocusable = $visibleQuickBuyItem.find('input[type="radio"]:not(:disabled)').first();
                    if ($firstFocusable.length) {
                        // Ensure the element is actually visible before focusing
                        const element = $firstFocusable[0];
                        if (element) {
                            element.focus();
                            return;
                        }
                    }
                }
                
                // Fallback: focus the dialog itself
                const dialogElement = $quickBuy[0];
                if (dialogElement) {
                    if (!$quickBuy.attr('tabindex')) {
                        $quickBuy.attr('tabindex', '-1');
                    }
                    dialogElement.focus();
                }
            }, 350);
        }
        
        // Clear the flag after a short delay
        setTimeout(function() {
            window.isOpeningMobileQuickBuy = false;
        }, 500);
    });
}

/**
 * Close mobile quick buy panel
 */
function closeMobileQuickBuy($quickBuy) {
    // Don't close if we're currently opening
    if (window.isOpeningMobileQuickBuy) {
        return;
    }
    
    // Get fresh reference in case element was moved
    const productId = $quickBuy.data('product-id');
    const instanceKey = quickBuyInstanceKey($quickBuy);
    $quickBuy = findQuickBuyByInstance(instanceKey, productId, $quickBuy);
    
    if (!$quickBuy.length) {
        return;
    }
    
    // Store reference to trigger button for focus restoration
    const triggerElement = $quickBuy.data('focus-trigger');
    
    // Remove swatches from drawer (they remain in desktop location)
    if ($(window).width() <= 767) {
        $quickBuy.find('.shop-grid-item-swatches').remove();
    }
    
    $quickBuy.removeClass('open');
    
    // Update aria attributes for accessibility
    const quickBuyId = $quickBuy.attr('id');
    if (quickBuyId) {
        const $trigger = $(`.shop-grid-item-quick-buy-trigger[aria-controls="${quickBuyId}"]`);
        if ($trigger.length) {
            $trigger.attr('aria-expanded', 'false');
        }
    }
    
    // Restore focus to the trigger button after closing animation
    if (triggerElement && document.contains(triggerElement)) {
        setTimeout(function() {
            triggerElement.focus();
        }, 100);
    }
    
    // Move quick buy back to original parent after closing (if it was moved to body)
    if ($quickBuy.parent().is('body')) {
        const originalParentElement = $quickBuy.data('original-parent-element');
        if (originalParentElement) {
            setTimeout(function() {
                // Get fresh reference before moving back
                const $quickBuyToMove = findQuickBuyByInstance(instanceKey, productId, $quickBuy);
                if ($quickBuyToMove.length && $quickBuyToMove.parent().is('body')) {
                    // Verify the parent element still exists in the DOM
                    if (document.contains(originalParentElement)) {
                        $quickBuyToMove.appendTo(originalParentElement);
                    } else {
                        // If parent is gone, find it via the grid item
                        const $gridItem = findGridCardByInstance(instanceKey, productId);
                        if ($gridItem.length) {
                            const $contentInner = $gridItem.find('.shop-grid-item__content-inner');
                            if ($contentInner.length) {
                                $quickBuyToMove.appendTo($contentInner);
                            }
                        }
                    }
                }
            }, 300);
        }
    }
}

/**
 * Update mobile quick buy to show the correct quick buy item based on swatch
 */
function updateMobileQuickBuyForSwatch($gridItem, $swatchWrap) {
    // Get productId - try data() first, then attr() as fallback for cloned elements
    const productId = $swatchWrap.data('prod-id') || $swatchWrap.attr('data-prod-id');
    const gridProductId = $gridItem.length ? $gridItem.data('product-id') : null;
    const $swatchLink = $swatchWrap.find('a');
    
    if (!productId) {
        return;
    }
    
    // Find quick buy - check both in grid item and in body (if moved)
    const gridInstanceKey = quickBuyInstanceKey($gridItem);
    let $quickBuy = null;
    if ($gridItem.length) {
        $quickBuy = $gridItem.find('.shop-grid-item__quick-buy');
    }
    if (!$quickBuy || !$quickBuy.length) {
        $quickBuy = findQuickBuyByInstance(gridInstanceKey, gridProductId);
        if (!$quickBuy.length) {
            // Fallback: find quick buy that contains this swatch
            $quickBuy = $swatchWrap.closest('.shop-grid-item__quick-buy');
        }
    }
    
    if (!$quickBuy || !$quickBuy.length) {
        return;
    }
    
    // Hide all quick buy items
    $quickBuy.find('.shop-grid-item__quick-buy-item').attr('hidden', true);
    
    // Show the matching quick buy item
    const $matchingQuickBuy = $quickBuy.find(`.shop-grid-item__quick-buy-item[data-ref="${productId}"]`);
    if ($matchingQuickBuy.length) {
        // Move swatches to the new visible item if they exist
        const $existingSwatches = $quickBuy.find('.shop-grid-item-swatches');
        if ($existingSwatches.length) {
            // Remove from current location
            $existingSwatches.detach();
            // Insert into the mobile swatches container of the matching item
            $matchingQuickBuy.find('.shop-grid-item-mobile-swatches').empty().append($existingSwatches);
            
            // Re-attach handlers after moving
            if ($(window).width() <= 767) {
                const $cardForHandlers = findGridCardByInstance(gridInstanceKey, gridProductId, $gridItem);
                if ($cardForHandlers.length) {
                    attachMobileSwatchHandlers($existingSwatches, $quickBuy, $cardForHandlers);
                }
            }
        }
        
        $matchingQuickBuy.removeAttr('hidden');
        if ($quickBuy.length && typeof window.syncQuickBuyPackForProductCard === 'function') {
            window.syncQuickBuyPackForProductCard($quickBuy[0]);
        }
        
        // Update height after showing the new item - recalculate for mobile
        if ($(window).width() <= 767) {
            renderQuickBuyGallery($matchingQuickBuy);
            updateMobileQuickBuyHeight($quickBuy);
        }
        
        // Update aria-labelledby to reference the visible title
        const $visibleTitle = $matchingQuickBuy.find('.shop-grid-item-title');
        if ($visibleTitle.length) {
            const titleId = $visibleTitle.attr('id');
            if (titleId) {
                $quickBuy.attr('aria-labelledby', titleId);
            }
        }
        
        // Update price and swatch in mobile header
        const $mobileHeader = $matchingQuickBuy.find('.shop-grid-item__quick-buy-mobile-header');
        if ($mobileHeader.length && $swatchLink.length) {
            // Update price - try data() first, then attr() as fallback for cloned elements
            const price = $swatchLink.data('price') || $swatchLink.attr('data-price');
            const comparePrice = $swatchLink.data('compare-price') || $swatchLink.attr('data-compare-price');
            const $priceContainer = $mobileHeader.find('.shop-grid-item-mobile-header-price .money');
            
            if (price) {
                if (comparePrice) {
                    // Show sale price with compare price
                    $priceContainer.html(`
                        <div class="flex-row justify-end">
                            <span style="display:inline-block; color:#FF965B;">${Shopify.formatMoney(price).replace(".00", "")}</span>
                            <span style="display:inline-block; text-decoration:line-through;padding-left:5px;">${Shopify.formatMoney(comparePrice).replace(".00", "")}</span>
                        </div>
                    `);
                } else {
                    // Show regular price
                    $priceContainer.html(`<span>${Shopify.formatMoney(price).replace(".00", "")}</span>`);
                }
            }
            
            // Update swatch display
            const $swatchName = $mobileHeader.find('.shop-grid-item-mobile-swatch-name');
            
            if ($swatchName.length) {
                // Get swatch name from the sr-only span
                const srOnlyText = $swatchWrap.find('.sr-only').text();
                let swatchNameText = '';
                
                if (srOnlyText) {
                    // Extract color name from "View {product} in {color} color"
                    const match = srOnlyText.match(/in (.+?) color/);
                    if (match && match[1]) {
                        swatchNameText = match[1];
                    }
                }
                
                // Fallback to data attribute if sr-only extraction failed
                if (!swatchNameText) {
                    const swatchColorLabel = $swatchLink.data('swatch-color-label') || '';
                    if (swatchColorLabel) {
                        // Capitalize first letter of each word from handleized version
                        swatchNameText = swatchColorLabel.split('-').map(word => 
                            word.charAt(0).toUpperCase() + word.slice(1)
                        ).join(' ');
                    }
                }
                
                if (swatchNameText) {
                    $swatchName.text(swatchNameText);
                }
            }
            
            // Update product image
            const productImageUrl = $swatchLink.data('product-image') || $swatchLink.attr('data-product-image');
            const $productImage = $mobileHeader.find('.shop-grid-item-mobile-product-image');
            if ($productImage.length && productImageUrl) {
                $productImage.attr('src', productImageUrl);
            }
            
            // Update links (title and image) with the swatch's href
            const swatchHref = $swatchLink.attr('href');
           
            if (swatchHref) {
                // Update title link
                const $titleLink = $mobileHeader.find('a.shop-grid-item-title');
                if ($titleLink.length) {
                    $titleLink.attr('href', swatchHref);
                }
                
                // Update image link
                const $imageLink = $mobileHeader.find('.shop-grid-item-mobile-header-image a');
                if ($imageLink.length) {
                    $imageLink.attr('href', swatchHref);
                }
            }
        }
    } else {
        // Fallback to first available
        const $firstQuickBuyItem = $quickBuy.find('.shop-grid-item__quick-buy-item').first();
        if ($firstQuickBuyItem.length) {
            $firstQuickBuyItem.removeAttr('hidden');
        }
    }
}

/**
 * Initialize all new quick buy functionality
 */
/**
 * Desktop "Quick add +" button (cards with data-quick-buy-trigger="button").
 * Toggles .quick-buy-open on the card, which the CSS renders exactly like the hover state.
 * Closes on pointer leave (mirrors hover), on click outside, on Escape, and when focus leaves the card.
 * All handlers are delegated so re-rendered grids need no re-binding.
 */
function initializeDesktopQuickAdd() {
    const cardSelector = '.shop-grid-item-v5[data-quick-buy-trigger="button"]';

    function closeCard($card) {
        if (!$card.length || !$card.hasClass('quick-buy-open')) return;
        $card.removeClass('quick-buy-open');
        $card.find('.shop-grid-item-quick-add').attr('aria-expanded', 'false');
    }

    function closeAllCards() {
        $(cardSelector + '.quick-buy-open').each(function() {
            closeCard($(this));
        });
    }

    $(document).off('.desktopQuickAdd');

    $(document).on('click.desktopQuickAdd', cardSelector + ' .shop-grid-item-quick-add', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const $button = $(this);
        const $card = $button.closest(cardSelector);
        const wasOpen = $card.hasClass('quick-buy-open');
        closeAllCards();
        if (wasOpen) return;
        updateQuickBuyHeight($card);
        $card.addClass('quick-buy-open');
        $button.attr('aria-expanded', 'true');
    });

    $(document).on('mouseleave.desktopQuickAdd', cardSelector, function() {
        closeCard($(this));
    });

    $(document).on('focusout.desktopQuickAdd', cardSelector, function(e) {
        // Only act on a real focus move (Tab out of the card). A null relatedTarget also fires
        // when mousing down on a non-focusable element such as a size label, so leave that to
        // the click-outside handler.
        const next = e.relatedTarget;
        if (!next || this.contains(next)) return;
        closeCard($(this));
    });

    $(document).on('click.desktopQuickAdd', function(e) {
        if ($(e.target).closest(cardSelector + '.quick-buy-open').length) return;
        closeAllCards();
    });

    $(document).on('keydown.desktopQuickAdd', function(e) {
        if (e.key === 'Escape') closeAllCards();
    });
}

function initializeNewQuickBuy() {
    assignQuickBuyInstanceKeys();
    initializeNewQuickBuySwatchHover();
    initializeNewQuickBuySizeSelection();
    initializeMobileQuickBuy();
    initializeDesktopQuickAdd();
    if (typeof window.initializeQuickBuyPackSizes === 'function') {
        window.initializeQuickBuyPackSizes();
    }
}

// Initialize all grid item functionality on page load
initializeQuickBuySelects();
initializeSwatchEvents();
initializeActiveSwatchBadges();
initializeQuickBuyMobile();
initializeNewQuickBuy();
initializeQuickBuyHeights();
if (typeof window.initializeQuickBuyPackSizes === 'function') {
    window.initializeQuickBuyPackSizes();
}

// Listen for filter updates and reinitialize grid items
document.addEventListener('filters:updated', function() {
    // Reinitialize all grid item functionality when filters are updated
    initializeGridItems();
    initializeQuickBuySelects();
    initializeSwatchEvents();
    initializeActiveSwatchBadges();
    initializeQuickBuyMobile();
    initializeNewQuickBuy();
    initializeQuickBuyHeights();
    if (typeof window.initializeQuickBuyPackSizes === 'function') {
        window.initializeQuickBuyPackSizes();
    }
});